import { ProductStatus } from '@lyka-pet-food/contracts'
import type { MealProduct, ExtraProduct } from '@repo/api-types'

/**
 * Compare two meal products for sorting purposes based on their sortIndex.
 */
export function compareMealPosition(a?: MealProduct, b?: MealProduct) {
  // If sort_index is not defined, we want to show the product last
  if (!a?.sortIndex) return -1
  if (!b?.sortIndex) return 1

  return a.sortIndex - b.sortIndex
}

/**
 * Compare two extra products (treats or supplements) for sorting purposes.
 */
type ComparableExtraProduct = Pick<ExtraProduct, 'name' | 'isNew' | 'status'>
export function compareExtrasProducts(a: ComparableExtraProduct, b: ComparableExtraProduct) {
  // Out of stock last
  if (a.status !== ProductStatus.OUT_OF_STOCK && b.status === ProductStatus.OUT_OF_STOCK) return -1
  if (a.status === ProductStatus.OUT_OF_STOCK && b.status !== ProductStatus.OUT_OF_STOCK) return 1
  // New products first
  if (a.isNew && !b.isNew) return -1
  if (!a.isNew && b.isNew) return 1
  // Alphabetical by name
  return a.name.localeCompare(b.name)
}

type VisibleProductStatus = ProductStatus.ACTIVE | ProductStatus.OUT_OF_STOCK
export function isProductVisible<T extends { status: ProductStatus; isVisible: boolean }>(
  product: T,
): product is T & { status: VisibleProductStatus; isVisible: true } {
  return (product.status === ProductStatus.ACTIVE || product.status === ProductStatus.OUT_OF_STOCK) && product.isVisible
}
